import type { SelectProps as AntSelectProps } from 'antd/es/select';
import cn from 'classnames';
import { Select as AntdSelect } from 'antd';
import { useCallback, useId, useMemo, useState } from 'react';

import { useMediaState } from '@/hooks/media';

import Icon from '../../icon';
import FieldsContainer from '../fields-container';

import css from './styles.module.scss';
import { defaultFilterOptions } from './helpers';

export interface ISelectProps extends AntSelectProps {
  source?: Map<string, string>;
  label?: string;
  requiredTag?: boolean;
  error?: string;
}

function Select({
  label,
  source,
  requiredTag,
  error,
  filterOption = defaultFilterOptions,
  ...props
}: ISelectProps) {
  const [isOpen, setOpen] = useState(false);

  const id = useId();
  const containerId = `selectContainer-${id}`;

  const keys = useMemo(() => {
    return source?.keys ? Array.from(source.keys()) : [];
  }, [source]);

  const classnames = useMemo(
    () => ({
      chevron: cn(css.chevron, {
        [css.chevronOpen]: isOpen,
      }),
    }),
    [isOpen],
  );

  const getTitle = useCallback((key: string) => source?.get(key), [source]);

  const suffixIcon =
    props.loading ? undefined : (
      <span className={classnames.chevron}>
        <Icon name="legacy/chevronDown" />
      </span>
    );

  const { isMobile } = useMediaState();

  return (
    <FieldsContainer error={error} requiredTag={requiredTag} label={label}>
      <div style={{ position: 'relative' }} id={containerId}>
        <AntdSelect
          loading={props.loading}
          suffixIcon={suffixIcon}
          style={{ width: '100%' }}
          onDropdownVisibleChange={setOpen}
          popupClassName={css.dropdown}
          status={error ? 'error' : ''}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          getPopupContainer={
            !isMobile ? undefined : () => document.getElementById(containerId)
          }
          filterOption={filterOption}
          {...props}
        >
          {keys.map((key) => (
            <AntdSelect.Option key={key} value={key} className={css.option}>
              {getTitle(key)}
            </AntdSelect.Option>
          ))}
        </AntdSelect>
      </div>
    </FieldsContainer>
  );
}

export default Select;
